import { DashboardFolderT, DashboardT } from 'business/definitions';

/**
 * Updates the list of dashboard folders by mapping each folder to include updated dashboards.
 * Filters out folders that have no dashboards if `canSeeEmptyFolders` is false.
 * The resulting folders are sorted alphabetically by their name.
 *
 * @param dashboardFolders - An array of dashboard folder objects to be updated.
 * @param dashboards - An array of dashboards to match and update within the folders.
 * @param canSeeEmptyFolders - A boolean indicating if the returned folders can include empty ones.
 * @returns A new array of updated and sorted dashboard folders containing the full Dashboard.
 */
export const updateDashboardFolders = (
    dashboardFolders: DashboardFolderT[],
    dashboards: DashboardT[],
    canSeeEmptyFolders: boolean,
): DashboardFolderT[] => {
    return dashboardFolders
        .map((folder) => ({
            ...folder,
            dashboards: folder.dashboards
                .map((fd) => dashboards.find((d) => d.key === fd.key) || null)
                .filter((d): d is DashboardT => Boolean(d))
                .sort((a, b) => a.title.localeCompare(b.title)),
        }))
        .filter((folder) => canSeeEmptyFolders || folder.dashboards.length > 0)
        .sort((a, b) => a.name.localeCompare(b.name));
};
